module.exports = __webpack_public_path__ + "img/youtube.a1cc6d6c.png";